<form [formGroup]="form" (ngSubmit)="changePass()">
  <mat-card class="card-container">
      <div class="card-content">
          <mat-card-title>
              Cambiar contraseña autogestión
          </mat-card-title>
          <mat-form-field class="full-width">
              <input autocomplete="off" matInput placeholder="Ingrese la nueva contraseña" formControlName="password" autofocus required>
              <mat-error *ngIf="form.hasError('required', 'password')">
                  Ingrese la contraseña
              </mat-error>
          </mat-form-field>

          <div style="text-align:right">
            <button [disabled]="loading" mat-button type="button" cdkFocusInitial (click)="close()">Salir</button>
              <button [disabled]="loading" mat-button type="submit">Cambiar</button>
          </div>
      </div>
  </mat-card>
</form>
